import { amenities as amenitiesData } from "../constants";
import { Chip, Stack, Typography, Grid, Box } from "@mui/material";

const Collage = ({ title, description, images, amenities, level, size }) => {
  const matchedAmenities = amenitiesData.filter((item) =>
    amenities?.includes(item.title)
  );

  return (
    <Grid container spacing={{ xs: 4, md: 8 }} mb={4}>
      <Grid item xs={12} md={3}>
        <Box sx={{ position: "sticky", top: 0 }}>
          <Typography color="#fff" variant="h6">
            {title}
          </Typography>
          {level !== undefined && (
            <Chip
              label={"level " + level}
              color="white"
              sx={{ height: 24, my: 1 }}
            />
          )}
          {description && (
            <Typography color="#ffffff70" variant="body1">
              {description}
            </Typography>
          )}
          {size && (
            <Typography color="#ffffff70" variant="body1">
              {"Size: " + size}
            </Typography>
          )}
          {matchedAmenities.length > 0 && (
            <Stack direction="row" spacing={1} pt={2}>
              {matchedAmenities.map((elem, idx) => (
                <Stack
                  key={idx}
                  color="white"
                  p={1}
                  borderRadius={3}
                  sx={{ aspectRatio: "1/1", background: "#ffffff30" }}
                >
                  {elem.icon}
                </Stack>
              ))}
            </Stack>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} md={9}>
        {images.length === 1 ? (
          <Box position="relative">
            <picture>
              <source srcSet={`${images[0]}.webp`} type="image/webp" />
              <img
                style={{ borderRadius: 16 }}
                src={`${images[0]}.jpg`}
                width="100%"
                alt={title}
              />
            </picture>
          </Box>
        ) : (
          <Box width="100%">
            <Box position="relative" mb={4}>
              <picture>
                <source srcSet={`${images[0]}.webp`} type="image/webp" />
                <img
                  style={{ borderRadius: 16 }}
                  src={`${images[0]}.jpg`}
                  width="100%"
                  alt={`${title}`}
                />
              </picture>
            </Box>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={4}
              width="100%"
            >
              {images.slice(1).map((img, index) => (
                <Box key={index} flex={1}>
                  <picture>
                    <source srcSet={`${img}.webp`} type="image/webp" />
                    <img
                      style={{ borderRadius: 16 }}
                      src={`${img}.jpg`}
                      width="100%"
                      alt={`${title} - ${index + 1}`}
                    />
                  </picture>
                </Box>
              ))}
            </Stack>
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default Collage;
